<template>
    <div class="external-activity--card" :style="`border-radius: ${activity.card_border_radius}px`">
        <div class="external-activity--card-content external-activity--card-flex">
            <div class="info-container">
                <h4>Ordine #{{ order.number }}</h4>
                <p>Servizio: {{ order.restaurant.name }}</p>
                <p>Data: {{ orderDate }}</p>
                <p>Totale: {{ (order.total / 100).toFixed(2) }}€</p>
                <p>Stato: {{ orderStatus }}</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'activity',
            'order',
            'language',
            'defaultLanguage'
        ],

        computed: {
            orderDate() {
                return moment(this.order.created_at).format("DD/MM/YYYY");
            },

            orderStatus() {
                var statuses = [
                    'Nuovo',
                    'Accettato',
                    'Consegnato',
                    'Rifiutato'
                ]
                return statuses[this.order.status];
            },
        },
    }
</script>
